import React, { useState } from 'react'

import './Gallery.css'
import ImageGrid from './ImageGrid'
import UploadForm from './UploadForm'



function MediaUpload() {

    const [selectedImg, setSelectedImg] = useState(null)

    return (
        <div>
            <UploadForm />
            <br /><br/>
            <ImageGrid setSelectedImg={setSelectedImg} />
        </div>
    )
}
export default MediaUpload